import { AppLayout } from 'layouts';
import { useLogout } from 'common/services/hooks';
import { Settings } from 'features/settings';
import { useSettingsTabsParams } from './hooks';

const PageSettings = () => {
  const tabOptions = useSettingsTabsParams();

  const logout = useLogout();

  return (
    <AppLayout>
      <Settings logOut={logout} tabOptions={tabOptions} />
    </AppLayout>
  );
};

export default PageSettings;
